













































import Vue from 'vue'
import UiCard from '@/components/UiCard.vue'
import UiButton from '@/components/UiButton.vue'
import UiIcon from '@/components/UiIcon.vue'

import i18n from '../i18n'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {German} from 'flatpickr/dist/l10n/de.js'
import {english} from 'flatpickr/dist/l10n/default.js'
import Tagify from '@yaireo/tagify'
import '@yaireo/tagify/dist/tagify.css'
import { LabelInterface } from '@/types/interfaces'

export default Vue.extend({
  name: "FeedFilters",
  props: {
    labels: Array,
    releasedAtStart: String,
    releasedAtEnd: String,
  },
  data(){
    return {
      organizationId: this.$store.getters.organization.id,
      datePickerConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "j. M y",
        locale: i18n.locale == "de" ? German : english,
      },
      labelFilterInputEl: null as any,
      filterDraft: {
        label: null as null | LabelInterface,
        dateRange: "",
      }
    }
  },
  methods: {
    handleFilterLabelChange(e: any){
      try {
        this.filterDraft.label = e.target.value ? JSON.parse(e.target.value)[0] : null
      } catch (error) { console.error("LABEL FILTER ERROR", e.target.value) }
    },
    handleFilterSubmit(){
      const query : any = {}

      if(this.filterDraft.label) query.labelIds = [this.filterDraft.label?.id]

      if(this.filterDraft.dateRange){
        const releaseDates = this.filterDraft.dateRange.split(/bis|to/).map(d => d.trim())
        query.releasedAtStart = releaseDates[0]
        query.releasedAtEnd = releaseDates[1] || releaseDates[0]
      }

      this.$router.push({ name: 'OrganizationFeed', params: { organizationId: this.organizationId}, query})
    },
    filterDates() {
      const conjunctionWord = i18n.locale == "de" ? "bis" : "to"
      return `${this.releasedAtStart} ${conjunctionWord} ${this.releasedAtEnd}`
    },
  },
  mounted(){
    const $component = this
    const labels = this.$store.getters.organizationLabelsAsArray

    const labelFilterInputEl = new Tagify(this.$refs.filterLabelInput, {
      mode: "select",
      whitelist: labels,
      enforceWhitelist: true,
      keepInvalidTags: false,
      autoComplete: {
        rightKey: true
      },
      dropdown: {
        closeOnSelect: true,
        maxItems: 10,
      },
      templates: {
        dropdownItem(data: any){
          try{
            return `<div class='tagify__dropdown__item ${data.class ? data.class : ""}' tagifySuggestionIdx="${data.tagifySuggestionIdx}">
                      ${data.img ?
                      `<img onerror="this.style.visibility='hidden'" src='${data.img}'>` : ''
                      }
                      <span>${data.value}</span>
                    </div>`
          } catch(err){}
        },
        dropdownItemNoMatch(data: any){
          return $component.$t('labelNotFound', {label: data.value})
        }
      }
    })
    this.labelFilterInputEl = labelFilterInputEl

    // Set initial tags
    this.labelFilterInputEl.addTags(this.labels)
    // Set initial dates
    this.filterDraft.dateRange = this.filterDates()
  },
  watch: {
    labels: function(newVersion, oldVersion){
      // Update prefilled labels:
      this.labelFilterInputEl.removeAllTags()
      this.labelFilterInputEl.addTags(this.labels)
    },
    releasedAtStart: function(newVersion, oldVersion){
      this.filterDraft.dateRange = this.filterDates()
    },
    releasedAtEnd: function(newVersion, oldVersion){
      this.filterDraft.dateRange = this.filterDates()
    },
  },
  components: {
    UiCard,
    UiButton,
    UiIcon,
    flatPickr,
  },
})
